import type { SystemStyleObject } from '@chakra-ui/react';
import {
  AbsoluteCenter,
  ProgressCircle as ChakraProgressCircle,
} from '@chakra-ui/react';
import * as React from 'react';

interface ProgressCircleRingProps extends ChakraProgressCircle.CircleProps {
  trackColor?: SystemStyleObject['stroke'];
  color?: SystemStyleObject['stroke'];
  cap?: SystemStyleObject['strokeLinecap'];
}

export const ProgressCircleRing = React.forwardRef<
  SVGSVGElement,
  ProgressCircleRingProps
>(function ProgressCircleRing(props, ref) {
  const { trackColor, cap, color, ...rest } = props;
  return (
    <ChakraProgressCircle.Circle {...rest} ref={ref}>
      <ChakraProgressCircle.Track stroke={trackColor} />
      <ChakraProgressCircle.Range stroke={color} strokeLinecap={cap} />
    </ChakraProgressCircle.Circle>
  );
});

export const ProgressCircleValueText = React.forwardRef<
  HTMLDivElement,
  ChakraProgressCircle.ValueTextProps
>(function ProgressCircleValueText(props, ref) {
  return (
    <AbsoluteCenter>
      <ChakraProgressCircle.ValueText {...props} ref={ref} />
    </AbsoluteCenter>
  );
});

export const ProgressCircleRoot = ChakraProgressCircle.Root;

interface ProgressCircleProps extends ChakraProgressCircle.RootProps {
  trackColor?: SystemStyleObject['stroke'];
  color?: SystemStyleObject['stroke'];
  cap?: SystemStyleObject['strokeLinecap'];
  thickness?: SystemStyleObject['strokeWidth'];
  value?: number;
  showPercentage?: boolean;
  percentageProps?: ChakraProgressCircle.ValueTextProps;
}

export const ProgressCircle = React.forwardRef<
  HTMLDivElement,
  ProgressCircleProps
>(function ProgressCircle(props, ref) {
  const {
    value,
    showPercentage = true,
    percentageProps,
    trackColor = 'status.pending',
    color = 'status.completed',
    cap = 'round',
    thickness,
    ...rest
  } = props;

  return (
    <ChakraProgressCircle.Root value={value} {...rest} ref={ref}>
      <ProgressCircleRing
        trackColor={trackColor}
        color={color}
        cap={cap}
        css={{ '--thickness': thickness }}
      />
      {showPercentage && <ProgressCircleValueText {...percentageProps} />}
    </ChakraProgressCircle.Root>
  );
});
